import { render, staticRenderFns } from "./GlobalConfirmDeleteDialog.vue?vue&type=template&id=5febd136"
import script from "./GlobalConfirmDeleteDialog.vue?vue&type=script&lang=js"
export * from "./GlobalConfirmDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports